import { render, staticRenderFns } from "./Downloadr.vue?vue&type=template&id=60ef110e&"
import script from "./Downloadr.vue?vue&type=script&lang=js&"
export * from "./Downloadr.vue?vue&type=script&lang=js&"
import style0 from "./Downloadr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports